/* eslint-disable complexity */
import React, { useContext } from 'react';
import { useOwnerProps } from '@elliemae/ds-props-helpers';
import { Carousel } from '../carousel/Carousel.js';
import { StyledMobileGradient, StyledTabList, StyledTabWrapper, StyledSubTabsList } from './styles.js';
import { DSTabsContext } from '../../DSTabsCTX.js';

import { TABS_DATA_TESTID, TAB_TYPES } from '../../constants/index.js';

import { TabBarItemRenderer } from './TabBarItemRenderer.js';

export const TabBar = (): JSX.Element => {
  const {
    tabsListRef,
    props,
    props: { type, fixedTabsHeaders, withCarousel, isDSMobile },
    globalClickHandler,
    mobileGradients,
    updateMobileGradients,
  } = useContext(DSTabsContext);
  const { getOwnerProps, getOwnerPropsArguments } = useOwnerProps(props);

  if (type === TAB_TYPES.SUBTABS && !isDSMobile) {
    return (
      <StyledSubTabsList
        getOwnerProps={getOwnerProps}
        getOwnerPropsArguments={getOwnerPropsArguments}
        withCarousel={withCarousel}
        data-testid={TABS_DATA_TESTID.SUB_TAB_LIST}
        role={withCarousel ? undefined : 'tablist'}
        innerRef={tabsListRef}
      >
        {withCarousel ? (
          <Carousel>
            <TabBarItemRenderer />
          </Carousel>
        ) : (
          <TabBarItemRenderer />
        )}
      </StyledSubTabsList>
    );
  }

  return (
    <StyledTabList
      getOwnerProps={getOwnerProps}
      getOwnerPropsArguments={getOwnerPropsArguments}
      withCarousel={withCarousel}
      role={withCarousel ? undefined : 'tablist'}
      innerRef={tabsListRef}
      data-testid={TABS_DATA_TESTID.TAB_LIST}
      isDSMobile={isDSMobile}
      fixedTabsHeaders={fixedTabsHeaders}
      mobileGradients={mobileGradients}
      onScroll={updateMobileGradients}
      tabType={type}
      onClick={(e) => {
        globalClickHandler({ event: e, target: 'tabsList' });
      }}
    >
      <StyledTabWrapper data-testid="tab-wrapper" isDSMobile={isDSMobile} fixedTabsHeaders={fixedTabsHeaders}>
        {!isDSMobile && withCarousel ? (
          <Carousel>
            <TabBarItemRenderer />
          </Carousel>
        ) : (
          <TabBarItemRenderer />
        )}
      </StyledTabWrapper>
      {isDSMobile && !fixedTabsHeaders && (
        <StyledMobileGradient
          mobileGradients={mobileGradients}
          left={tabsListRef.current?.scrollLeft}
          width={tabsListRef.current?.scrollWidth}
        />
      )}
    </StyledTabList>
  );
};
